import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setReferalId } from "../../redux/actions/user";


const ReferalPage =()=>{
    const auth = useSelector((state) => state.auth);
    const userCur = useSelector(state => state.currentUser?.user || {});

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentId = useParams().id;
    
   

    useEffect(() => {
        if(auth.isLoggedIn){
            dispatch(setReferalId({referalId:currentId,id:userCur.id})).then(res=>{
                navigate('/');
            })            
        }else{
            localStorage.setItem('referalId',currentId);
            navigate('/login');
        }
    }, [auth,currentId,userCur ]);
}


export default ReferalPage;